import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export let DragDropService = /*#__PURE__*/(() => {
  class DragDropService {
    constructor() {
      this.onDrop = new EventEmitter();
      this.onDropOutside = new EventEmitter();
      this.dragging = [];
    }
    beginDragging(element, event) {
      this.dragging.push({
        element,
        droppedOnDroppable: false,
        scope: element.scope,
        startOffsetLeft: event.offsetX,
        startOffsetTop: event.offsetY
      });
    }
    endDragging(element, event) {
      const indexToRemove = this.dragging.findIndex(info => {
        return info.element === element;
      });
      if (indexToRemove === -1) return;
      const extracted = this.dragging.splice(indexToRemove, 1)[0];
      if (!extracted.droppedOnDroppable) {
        this.droppedOutside(extracted, event);
      }
    }
    findDraggedElementByScope(scope) {
      // console.log('findDraggedElementByScope',this.dragging)
      let match;
      if (Array.isArray(scope)) {
        scope = scope.map(s => s.toLowerCase());
        match = this.dragging.find(info => {
          return scope.includes(info.scope.toLowerCase());
        });
      } else {
        scope = scope.toLowerCase();
        match = this.dragging.find(info => {
          return info.scope.toLowerCase() === scope;
        });
      }
      return match || false;
    }
    droppedOnDroppable(droppable, event, extraData = null) {
      try {
        const droppableScope = droppable.scope;
        if (!droppableScope) {
          return console.warn('droppable has no scope set, aborting DragDrop event generation.');
        }
        const draggableInfo = this.findDraggedElementByScope(droppableScope);
        if (!draggableInfo) return;
        draggableInfo.droppedOnDroppable = true;
        const draggable = draggableInfo.element;
        this.endDragging(draggable);
        const droppableRect = droppable.el.nativeElement.getBoundingClientRect();
        const droppableSize = {
          x: droppableRect.width,
          // +1 fixes a minor layout bug causing line breaks on clones
          y: droppableRect.height
        };
        const offset = {
          x: event.clientX - draggable.cursorOffset.x - droppableRect.left,
          y: event.clientY - draggable.cursorOffset.y - droppableRect.top
        };
        this.onDrop.emit({
          scope: droppableScope,
          draggable,
          droppable,
          draggableSize: draggable.elementSize,
          droppableSize,
          offset,
          extraData
        });
      } catch (err) {
        console.error(err);
      }
    }
    droppedOutside(draggableInfo, event) {
      try {
        const draggable = draggableInfo.element;
        const offset = {
          x: event.clientX,
          y: event.clientY
        };
        this.onDropOutside.emit({
          scope: draggable.scope,
          draggable,
          draggableSize: draggable.elementSize,
          offset
        });
      } catch (err) {
        console.error(err);
      }
    }
    static {
      this.ɵfac = function DragDropService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DragDropService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DragDropService,
        factory: DragDropService.ɵfac
      });
    }
  }
  return DragDropService;
})();